import { createContext } from "react";
const Multipage_ByteMiniWebDashboardContext = createContext({});
export default Multipage_ByteMiniWebDashboardContext;
